import { TILESROUTE } from "./constants";

const checkValidity = (value, rules) => {
  let isValid = true;

  const EMAIL_PATTERN =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

  // const MOBILE_PATTERN = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  const MOBILE_PATTERN = /^\d{10,15}$/;

  const IS_NUMERIC_PATTERN = /^\d+$/;

  switch (rules.check) {
    case "required":
      return Array.isArray(value)
        ? value.length > 0 && isValid
        : typeof value === "object"
        ? value.value.trim() !== "" && isValid
        : value.trim() !== "" && isValid;
    case "validEmail":
      return EMAIL_PATTERN.test(value) && isValid;
    case "validMobile":
      return MOBILE_PATTERN.test(value) && isValid;
    case "minLength":
      return value.length >= rules.minLength && isValid;
    case "maxLength":
      return value.length <= rules.maxLength && isValid;
    case "isNumeric":
      return IS_NUMERIC_PATTERN.test(value) && isValid;
    default:
      return true;
  }
};

export const validateInput = (updatedFormElement) => {
  const validationRules = updatedFormElement.validation;
  let isValid = true;
  let errorMessage = "";
  if (typeof validationRules !== "undefined" && validationRules.length > 0) {
    for (let i = 0; i < validationRules.length; i++) {
      isValid = checkValidity(updatedFormElement.value, validationRules[i]);
      if (!isValid) {
        errorMessage = validationRules[i].message;
        break;
      }
    }
  }

  updatedFormElement.isValid = isValid;
  updatedFormElement.errorMessage = errorMessage;

  return updatedFormElement;
};

export const checkFormValidity = (updatedForm) => {
  let formIsValid = true;

  for (let element in updatedForm) {
    if (element == "referral") {
      updatedForm.referral.forEach((referral) => {
        let keys = Object.keys(referral);
        let name = keys[0];
        let email = keys[1];
        let phone = keys[2];

        formIsValid = referral[name].isValid && formIsValid;
        formIsValid = referral[email].isValid && formIsValid;
        formIsValid = referral[phone].isValid && formIsValid;
      });
    } else {
      formIsValid = updatedForm[element].isValid && formIsValid;
    }
  }
  return formIsValid;
};

export const checkTilesRoute = (queryString) => {
  if (queryString == "look_and_feel" || queryString == "color") {
    return TILESROUTE.productRoute;
  } else if (queryString == "collection" || queryString == "location") {
    return TILESROUTE.collectionRoute;
  }
};
